import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
} from "reactstrap";

const EditarCard = (props) => {
  // ** Const
  // ** Props
  const { open, setOpen, cardSelected } = props;
  const [ordem, setOrdem] = useState(0);
  const [card, setCard] = useState({
    nameOld: cardSelected?.titulo,
    name: cardSelected?.titulo,
    width: cardSelected?.largura,
    height: cardSelected?.altura,
    tipoAba: cardSelected?.tipoAba,
    ordem: cardSelected?.ordem,
    id: cardSelected?.idCard
  });

  useEffect(() => {
    setCard({
      nameOld: cardSelected?.titulo,
      name: cardSelected?.titulo,
      width: cardSelected?.largura,
      height: cardSelected?.altura,
      tipoAba: cardSelected?.tipoAba,
      ordem: cardSelected?.ordem,
      idCard: cardSelected?.idCard
    });
    setOrdem(cardSelected?.ordem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardSelected]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let area = localStorage.getItem("area");
    //let menu = localStorage.getItem("menu_completo")?.replace(/\//g, "|");
    let menus = JSON.parse(localStorage.getItem("menus"));
      let menuSelecionado = menus?.find(
        (item) =>
          // eslint-disable-next-line eqeqeq
          item.area == localStorage.getItem("area") &&
          // eslint-disable-next-line eqeqeq
          item.id == localStorage.getItem("idMenu")
      );
    if (card.ordem === ordem) {
      let model = {
        params: {
          arg1: area,
          arg2: menuSelecionado?.menu,
          arg3: card.name,
          arg4: card.width,
          arg5: card.height,
          arg6: card.nameOld,
          arg7: card.tipoAba,
          arg8: card.ordem,
        },
      };
      props.updateCard(model);
    } else {
      const from = ordem;
      const to = card.ordem;
      card.ordem = ordem;
      props.handleOrderCard(card, Number(from), Number(to));
    }
    setOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader toggle={() => setOpen(!open)}>Editar Card </ModalHeader>
      <ModalBody>
        <Form id="form" className="mb-2">
          <FormGroup>
            <Label for="nome">Título</Label>
            <Input
              type="text"
              id="name"
              placeholder="Título"
              value={card.name}
              name="name"
              onChange={(e) =>
                setCard({
                  ...card,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="width">Largura</Label>
            <Input
              type="number"
              id="width"
              placeholder="Largura de 1 a 12"
              value={card.width}
              name="width"
              onChange={(e) =>
                setCard({
                  ...card,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="height">Altura</Label>
            <Input
              type="text"
              id="height"
              placeholder="Altura em pixels"
              value={card.height}
              name="height"
              onChange={(e) =>
                setCard({
                  ...card,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="ordem">Ordem</Label>
            <Input
              type="number"
              min={1}
              id="ordem"
              placeholder="Ordenação na página"
              value={card.ordem}
              name="ordem"
              onChange={(e) => {
                const value =
                  e.target.value < 1 || e.target.value > props.maxSize
                    ? card.ordem
                    : e.target.value;
                setCard({
                  ...card,
                  [e.target.name]: value,
                });
              }}
            />
          </FormGroup>
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={card.tipoAba}
                onChange={(e) =>
                  setCard({
                    ...card,
                    tipoAba: !card.tipoAba,
                  })
                }
              />
              Tipo abas{" "}
              <span style={{ fontSize: "9px" }}>
                *(Existem dois tipos de formato de abas: padrão e menu dropdown. Se 'Tipo abas' estiver marcado, o formato das abas será padrão. Caso contrário, as abas serão mostradas dentro de um menu dropdown.)
              </span>
            </Label>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleSubmit(e)} color="primary">
          Editar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default EditarCard;
